export default ({ commit }, categories) => {
  commit("SET_CATEGORIES", categories);
};
